export default __webpack_public_path__ + "beta-maps-guides-migrate-basic-map-960-94a8e73ad21c28f1348fde5500e30019.png";